export const SORT_OPTIONS = {
	items: [
		{
			label: 'sort-by-most-relevant',
			value: `${process.env.NEXT_PUBLIC_ALGOLIA_INDEX}`,
		},
		{
			label: 'sort-by-most-recent',
			value: `${process.env.NEXT_PUBLIC_ALGOLIA_INDEX}_most_recent`,
		},
	],
}

export const isMostRecentSort = (currentRefinement: string): boolean =>
	currentRefinement.includes('most_recent')
